import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	opsgenieSchedulePromoHeading: {
		id: 'opsgenie-schedule.components.try-it-now-component.opsgenie-schedule-promo-heading',
		defaultMessage: 'Create on-call schedules for your Jira project',
		description: 'The promo header introducing the on-call schedule page in a next-gen project.',
	},
	opsgenieSchedulePromoInfo: {
		id: 'opsgenie-schedule.components.try-it-now-component.opsgenie-schedule-promo-info',
		defaultMessage:
			'Help your team stay in control when something goes wrong. Opsgenie gives your team the power to create on-call schedules and seamlessly link them with your projects in Jira. ',
		description: 'The promo description of the on-call schedule page in a next-gen project.',
	},
	opsgenieSchedulePromoTryNowButton: {
		id: 'opsgenie-schedule.components.try-it-now-component.opsgenie-schedule-promo-try-now-button',
		defaultMessage: 'Try Opsgenie',
		description: 'The CTA button text on the on-call schedule page in a next-gen project.',
	},
	opsgenieSchedulePromoRequestTrialButton: {
		id: 'opsgenie-schedule.components.try-it-now-component.opsgenie-schedule-promo-request-trial-button',
		defaultMessage: 'Request trial',
		description:
			'The CTA button text for basic user on the on-call schedule page in a next-gen project.',
	},
	opsgenieSchedulePromoLearnMoreButton: {
		id: 'opsgenie-schedule.components.try-it-now-component.opsgenie-schedule-promo-learn-more-button',
		defaultMessage: 'Learn more',
		description: 'The learn more button text on the on-call schedule page in next-gen project.',
	},
	xflowContextHeading: {
		id: 'opsgenie-schedule.components.try-it-now-component.xflow-context-heading',
		defaultMessage: 'Link powerful incident management to Jira',
		description: 'The heading text on the confirm trial modal.',
	},
	xflowContextMessage: {
		id: 'opsgenie-schedule.components.try-it-now-component.xflow-context-message',
		defaultMessage:
			'Opsgenie helps you respond to critical issues before they impact your business. Set up automated alerts, on-call schedules, and a seamless link with your Jira projects.',
		description: 'The message text on the confirm trial modal.',
	},
	xflowContextTrialCta: {
		id: 'opsgenie-schedule.components.try-it-now-component.xflow-context-trial-cta',
		defaultMessage: 'Try Opsgenie on a 14-day trial',
		description: 'The CTA text on the confirm trial modal.',
	},
});
